import { UserManager, WebStorageStateStore, UserManagerSettings, Log } from 'oidc-client-ts';

// 环境变量类型定义
declare global {
  interface ImportMetaEnv {
    VITE_OIDC_SERVER_URL: string;
    VITE_OIDC_WEB_URL: string;
    VITE_OIDC_WEB_SSO_URL: string;
    VITE_OIDC_CLIENT_SECRET: string;
    VITE_OIDC_CLIENT_ID: string;
  }
}

// 基础配置
const isDev = import.meta.env.MODE === 'development';

export const identityServerBase = import.meta.env.VITE_API_BASE_URL; // 目标服务器登录地址
export const clientId = import.meta.env.VITE_OIDC_CLIENT_ID;
export const appBase = import.meta.env.VITE_APP_BASE_URL;  // 本系统地址
export const ssoBase = import.meta.env.VITE_OIDC_SSO_URL; // sso系统地址
export const clientSecret = import.meta.env.VITE_OIDC_CLIENT_SECRET || 'secret'; // 密钥


// OIDC配置
const oidcConfig: UserManagerSettings = {
  authority: identityServerBase, // OIDC/OAuth2 提供者的 URL
  client_id: clientId, // 客户端应用程序ID
  client_secret: clientSecret,
  redirect_uri: `${appBase}/callback`, // 登录回调地址
  post_logout_redirect_uri: `${ssoBase}/logout`, // SSO统一登出地址
  scope: 'api openid profile offline_access',
  response_type: 'code',
  
  // 使用localStorage存储用户信息和tokens
  userStore: new WebStorageStateStore({ 
    store: window.localStorage,
    prefix: 'oidc.'
  }),
};

console.log('初始化配置信息oidcConfig', oidcConfig);

// 创建UserManager实例
export const userManager = new UserManager(oidcConfig);

// 事件监听器
// userManager.events.addUserLoaded((user) => {
//   console.log('用户已加载', user);
// });

// userManager.events.addSilentRenewError((error) => {
//   console.error('静默更新失败', error);
// });

// userManager.events.addAccessTokenExpiring(() => {
//   console.log('访问令牌即将过期');
// });

// userManager.events.addAccessTokenExpired(() => {
//   console.log('访问令牌已过期');
// });

export default userManager;
